module.exports = __webpack_public_path__ + "img/Beta Digitis.50102377.gif";